import axios from "axios";
import END_POINT from "../config/endpoints.constants";
import { UUID, APIResponse, APIResult } from "../types";
import { getErrorMessage } from "../lib/error-handling";
import { HUJoinCall } from "../types/call";

export interface MakeCallResult extends APIResult {
  data?: {
    callDetail: HUJoinCall;
  };
}

export interface HUJoinCallResponse extends APIResponse {
  data: HUJoinCall;
}

export interface HUJoinCallOptions {
  requestId: UUID;
}

export default async function huJoinCall(options: HUJoinCallOptions, config: any = {}) {
  const result: MakeCallResult = {};
  try {
    const { data: responseData } = await axios.post<HUJoinCallResponse>(
      END_POINT.HU_JOIN_CALL,
      options,
      config
    );

    if (responseData?.code === 0) {
      result.data = {
        callDetail: responseData.data,
      };
    } else if (responseData?.code === 1) {
      result.error = responseData.message;
    } else if (responseData?.data) {
      result.data = {
        callDetail: responseData.data,
      };
      result.error = responseData.message;
    } else {
      result.error = responseData.message;
    }
  } catch (error: any) {
    result.error = getErrorMessage(error);
  }
  return result;
}
